import * as React from 'react'
import { InfoSectionItem, type InfoSectionItemProps } from './InfoSectionItem'

export function ContactList(props: { items: InfoSectionItemProps[] }) {
    return (
        <div className="AppCore__ui__UserProfile__ContactList">
            {props.items.map((item, i) => (
                <InfoSectionItem {...item} key={`contact-list-item-${i}`} />
            ))}
        </div>
    )
}
